import React from 'react';
import { motion } from 'framer-motion';

// Import icons or logos for programming languages
import JavaScriptLogo from '../Icons/Javascript-logo.png'; // Replace with actual icons or logos
import JavaLogo from '../Icons/java-logo.png'
import plsql from '../Icons/plsql-logo.png'

// Import icons or logos for frameworks and libraries
import ReactLogo from '../Icons/react-logo.png';
import ExpressLogo from '../Icons/express-logo.png';
import NodejsLogo from '../Icons/nodejs-logo.png';

// Import icons or logos for databases
import MySQLLogo from '../Icons/mysql-logo.png';
import MongoDBLogo from '../Icons/mongodb-logo.png';
import FirebaseLogo from '../Icons/firebase-logo.png';

// Import icons or logos for tools and platforms
import GitLogo from '../Icons/git-logo.png';
import GitHubLogo from '../Icons/github-logo.png';
import WordPressLogo from '../Icons/wordpress.png';
import RenderLogo from '../Icons/render-logo.png';
import AWS from '../Icons/AWS-logo.png'


const Skills = () => {
  const skills = [
    {
      type: "Programming Languages",
      description: "JavaScript, PL/SQL, Java",
      icons: [JavaScriptLogo, plsql, JavaLogo]
    },
    {
      type: "Frameworks and Libraries",
      description: "React, Express, Node.js",
      icons: [ReactLogo, ExpressLogo, NodejsLogo]
    },
    {
      type: "Databases",
      description: "MySQL, MongoDB, Firebase",
      icons: [MySQLLogo, MongoDBLogo, FirebaseLogo]
    },
    {
      type: "Tools and Platforms",
      description: "Git, Github, Firebase, WordPress, Render, AWS",
      icons: [GitLogo,GitHubLogo, WordPressLogo, RenderLogo, AWS]
    },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 md:px-8 lg:px-16" id="skills">
      <h1 className="text-2xl md:text-4xl font-bold mb-8">Skills</h1>
      <div className="max-w-6xl w-full grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {skills.map((skill, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-white p-6 rounded-lg shadow-lg w-full"
          >
            <h2 className="text-xl font-semibold">{skill.type}</h2>
            <div className="flex flex-wrap justify-center gap-4 mt-4">
              {skill.icons.map((icon, idx) => (
                <img key={idx} src={icon} alt={`${skill.type} - ${idx}`} className="h-10 w-10 md:h-20 md:w-16 object-contain" />
              ))}
            </div>
            <h2 className="text-gray-700 text-center font-semibold mt-4">{skill.description}</h2>
          </motion.div>
        ))}
      </div>
    </div>
  );
  
  
};

export default Skills;
